import React from "react"
import Link from "components/Link"
import NavPanel from "./NavPanel"

function NavItem({ path, label, items, ...rest }) {
  return (
    <li className="group relative" key={label}>
      <Link
        className="inline-block whitespace-nowrap py-3 text-current transition-colors group-hover:text-lush"
        href={path || items[0].path}
      >
        {label}
      </Link>
      <NavPanel items={items} {...rest} />
    </li>
  )
}

export default NavItem
